import React from 'react'
import './logoHls.css'

function C2wSuperxlogoHld() {
  return (
    <div className='C2wSuperxlogoHld_ctn'>
        <img src='/assets/superx/images/C2wSuperx.png' alt='super-x logo' />
    </div>
  )
}

export default C2wSuperxlogoHld;

